import styled from 'styled-components'

export const Anchor = styled.div`
  height: 1rem;
  oveflow-anchor: auto;
`

export const Container = styled.div`
  display: inline-flex;
  overflow: auto;
  flex: 1;
  flex-direction: column;
  alight-items: stretch;
  justify-content: stretch;
  width: 100%;
`

export const ChatBox = styled.div`
  ${({ theme: { colors } }) => `
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  overflow-y: auto;
  padding: 0.75rem;
  flex: 1;
  background: ${colors('shadow', 0.3)};
  border: 1px solid ${colors('foreground', 0.1)};
  `}
`

export const Blurb = styled.div`
  ${({ theme: { colors, monoFont } }) => `
    background: ${colors('chrome')};
    border: 1px solid ${colors('foreground', 0.12)};
    color: ${colors('text')};
    padding: 0.4rem 0.75rem;
    font-family: ${monoFont};
    font-size: 0.8rem;
    max-width: 75%;
    align-self: flex-start;
    overflow-anchor: none;
    &.current {
      background: ${colors('link', 0.12)};
      border-color: ${colors('link', 0.35)};
      align-self: flex-end;
    }
    &.system {
      align-self: center;
      color: ${colors('foreground', 0.55)};
      font-style: italic;
      white-space: pre-line;
      max-width: 90%;
    }
  `}
`

export const User = styled.div`
  ${({ theme: { colors, monoFont } }) => `
    font-family: ${monoFont};
    font-size: 0.65rem;
    color: ${colors('foreground', 0.4)};
    margin-bottom: 0.2rem;
    letter-spacing: 0.05em;
  `}
`

export const InputRow = styled.div`
  ${({ theme: { colors } }) => `
  display: flex;
  gap: 0;
  border: 1px solid ${colors('foreground', 0.15)};
  border-top: none;
  `}
`

export const EmojiWrapper = styled.div`
  ${({ theme: { colors, monoFont } }) => `
  flex: 1;
  .react-input-emoji--container {
    margin: 0;
    border-radius: 0;
    border: none;
  }
  .react-input-emoji--input {
    font-family: ${monoFont};
    font-size: 0.8rem;
    color: ${colors('text')};
    padding: 0.6rem 0.75rem;
      height: 3rem;
  }
  .react-input-emoji--placeholder {
    font-family: ${monoFont};
    font-size: 0.8rem;
    color: ${colors('foreground', 0.3)};
    left: 12px;
  }
  .react-input-emoji--button {
    background: none;
    border: none;
    border-left: 1px solid ${colors('foreground', 0.1)};
    padding: 0 0.5rem;
  }
  .react-input-emoji--button svg {
    fill: ${colors('foreground', 0.3)};
  }
  .react-input-emoji--button__show svg,
  .react-input-emoji--button:hover svg {
    fill: ${colors('highlight')};
  }
  `}
`
